/**
 * @voltxampere/engine — Potentiometer AC stamp (Sprint 23 B4)
 *
 * Pot pure conductance — frequency-independent. AC stamp aynı 6-cell
 * pattern'ı complex matrix'e (re, im=0) yazar.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { getTerminalNetId } from "../terminal-utils.js";
import { resolvePotentiometerParams } from "../linear/potentiometer.js";
export const potentiometerACStamp = (ctx, component) => {
    const { resistance, position } = resolvePotentiometerParams(component.id, component.params);
    const G_tw = 1 / (resistance * position);
    const G_wb = 1 / (resistance * (1 - position));
    const t = ctx.nodeIndex(getTerminalNetId(component, "top"));
    const w = ctx.nodeIndex(getTerminalNetId(component, "wiper"));
    const b = ctx.nodeIndex(getTerminalNetId(component, "bottom"));
    ctx.addY(t, t, G_tw, 0);
    ctx.addY(w, w, G_tw + G_wb, 0);
    ctx.addY(b, b, G_wb, 0);
    ctx.addY(t, w, -G_tw, 0);
    ctx.addY(w, t, -G_tw, 0);
    ctx.addY(w, b, -G_wb, 0);
    ctx.addY(b, w, -G_wb, 0);
};
//# sourceMappingURL=potentiometer.js.map